/**
 * vendor
 */
import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

/**
 * Shared
 */
import PrivateRoute from 'app/PrivateRoute';
import Spinner      from '@shared/components/base/Spinner';
import ROUTES       from '@shared/lib/constants/routes';
import { openLoginModal } from 'mfe/auth-bridge';

/**
 * Features
 */
const PlayerTicketDetail = lazy(() => import('@features/player-tickets/pages/Detail'));

/**
 * Player
 */
const PlayerMyBets = lazy(()       => import('@features/mybets/pages/list/Page'));
const PlayerProfile = lazy(()       => import('@features/profile/pages/Page'));

/**
 * Players App routes
 *
 * @return {DOM}
 */
function AppRoutes() {
  function LoginRedirect() {
    React.useEffect(() => {
      openLoginModal();
    }, []);
    return <Navigate to={ROUTES.DEFAULT} replace />;
  }

  return (
    <Suspense fallback={<Spinner/>}>
      <Routes>
        {/* Redirect /player/my-bets (with hyphen) to /player/mybets (without hyphen) */}
        <Route path="/sports/player/my-bets" element={<Navigate to={ROUTES.PLAYER.MYBETS} replace />} />

        <Route
          path={ROUTES.PLAYER.MYBETS}
          element={<PrivateRoute component={PlayerMyBets} />}
        />

        <Route
          path={ROUTES.PLAYER.PROFILE}
          element={<PrivateRoute component={PlayerProfile} />}
        />

        <Route
          path={ROUTES.PLAYER.TICKET.DETAIL}
          element={<PrivateRoute component={PlayerTicketDetail} />}
        />

        <Route path="*" element={<LoginRedirect />} />
      </Routes>
    </Suspense>
  );
}

export default AppRoutes;

